<template>
  <div class="notifications-list">
    <NotificationItem
      v-for="n in notifications"
      :key="n.id"
      :notification="n"
    />

    <VProgressLinear
      v-if="isLoadingMore"
      indeterminate
      color="primary"
      class="notifications-list__loader"
    />
  </div>
</template>

<script>
import NotificationItem from './NotificationItem.vue';

export default {
  name: 'NotificationsList',
  components: {
    NotificationItem,
  },
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-list {
  max-width: 620px;
  width: 100%;
}

.notifications-list__loader {
  margin-top: 12px;
}

@media screen and (min-width: 1600px) {
  .notifications-list {
    max-width: 860px;
  }
}
</style>
